// Education data store

export const education = [
  {
    id: "btech-sri-eshwar",
    institution: "Sri Eshwar College of Engineering",
    degree: "B.Tech Computer Science and Business Systems",
    duration: "2022 - 2026",
    startDate: "2022-06-01",
    endDate: "2026-05-31",
    cgpa: "8.02",
    description: "Pursuing Bachelor of Technology in Computer Science and Business Systems with a focus on full-stack development and AI/ML technologies.",
    highlights: [
      "CGPA: 8.02/10",
      "Specialized in Computer Science and Business Systems",
      "Focused on full-stack development and AI/ML",
      "Active participation in technical projects and internships"
    ]
  }
];
